import { Component } from "react";
import axios from "./api.service";

export default class UserService extends Component {
	static async createUser(user) {
		return axios.post(`/user/create`, user);
	}

	static async listAllUsers() {
		return axios
			.get(`/user/getAll`)
			.then((res) => {
				return res.data.users.sort((a, b) => {
					if (a.displayName > b.displayName) return 1;
					if (a.displayName < b.displayName) return -1;
					return 0;
				});
			})
			.catch((err) => {
				console.error(err);
				return [];
			});
	}

	static async listOneUser(uid) {
		return axios
			.get(`/user/getOne/${uid}`)
			.then((res) => {
				res.data.user.cpf = res.data.userData.cpf;
				res.data.user.levels = res.data.userData.levels;
				return res.data.user;
			})
			.catch((err) => console.error);
	}

	static async updateUser(uid, body) {
		return axios.put(`/user/edit/${uid}`, body);
	}

	static async deleteUser(uid) {
		return axios.delete(`/user/delete/${uid}`);
	}

	static async addLevels(uid, levels) {
		return axios.put(`/user/addLevels/${uid}`, { levels: levels });
	}

	static async freeDevice(uid) {
		return axios.put(`/user/freeDevice/${uid}`, {});
	}
}
